import { useNavigate } from "react-router-dom";
import DetailRow from "../../../components/UI/viewDialogs/DetailRow";
import Modal from "../../../components/portal/Modal";
import GradientButton from "../../../components/UI/buttonUI/GradientButton";
import successIcon from "../../../assets/icons/successIcon.svg";
import { CylinderFillStatus } from "../utils/CylinderStatusOverview";

export default function CylinderUpdateSuccessView({ viewDetails }) {
  const navigate = useNavigate();
  return (
    <Modal modalWidth="view-dialog-content">
      <img src={successIcon} alt="messageIcon" className="mx-auto mb-1 w-9" />
      <p className="view-success-msg-d">Cylinder Successfully Updated!</p>
      <div className={`px-2 overflow-auto`}>
        <div className="dialog-sub-title">Cylinder Details</div>
        <div className="view-dialog-content-wrap">
          <DetailRow title="Cylinder No." value={viewDetails.serialNumber} />
          <DetailRow title="Size" value={`${viewDetails.size}kg`} />
          <DetailRow
            title="Fill Status"
            value={
              <CylinderFillStatus status={viewDetails.currentState.isFilled} />
            }
          />
        </div>
        <div className="dialog-sub-title">Station Details</div>
        <div className="view-dialog-content-wrap">
          <DetailRow title="Station ID" value={viewDetails.station.id} />
          <DetailRow title="Station Name" value={viewDetails.station.name} />
        </div>
      </div>
      <div className="pt-5 text-center">
        <GradientButton
          btnText="Ok"
          width="w-28"
          onClick={() => navigate("/sites/cylinders")}
        />
      </div>
    </Modal>
  );
}
